export interface IDynamicCasinoJackpotConfig {
    available: boolean;
}

export interface IJackpotCasinoState {
    enabled: boolean;
    statusLevels: Array<TJackpotCasinoLevelItem>;
    hitsLevels: Array<TJackpotCasinoUsersHitLevelItem>;
    userHit?: TJackpotCasinoUsersHit;
}

export type TJackpotCasinoLevelItem = {
    levelId: string;
    levelName: string;
    currentValue: number;
    levelOrder: number;
    timestamp: string;
};

export type TJackpotCasinoStatus = {
    jackpotId: string;
    jackpotName: string;
    games: string[];
    levels: Array<TJackpotCasinoLevelItem>;
};

export type TJackpotCasinoUsersHitLevelItem = {
    levelId: string;
    levelName: string;
    hitValue: number;
    hitTimestamp: string;
    levelOrder: number;
};

export type TJackpotCasinoUsersHit = {
    jackpotId: string;
    jackpotName: string;
    levels: Array<TJackpotCasinoUsersHitLevelItem>;
};

export enum TJackpotCasinoEventTypes {
    JACKPOT_STATUS = 'JackpotStatus',
    JACKPOT_HIT = 'JackpotHit',
    JACKPOT_ENABLED = 'JackpotEnabled',
    JACKPOT_DISABLED = 'JackpotDisabled'
}

export type TJackpotCasinoNotification = {
    event: string;
    status: TJackpotCasinoStatus;
    hit: TJackpotCasinoUsersHit;
};
